!((document, Drupal, drupalSettings, $, inView) => {
  'use strict';
  Drupal.behaviors.history = {
    attach: function (context, settings) {
      const navigator = $('.history__navigator__date');
      const items = $('.history__navigator__date__item');

      const mobileNavigator = $('.history__navigator--mobile');
      const mobileNavigatorNavigation = $('.history__navigator--mobile__navigation');
      const mobileNavigatorNavigationLeft = $('.history__navigator--mobile__navigation.left');
      const mobileNavigatorNavigationRight = $('.history__navigator--mobile__navigation.right');
      const mobileItems = $('.history__navigator--mobile__date__item');
      const mobileItemsNumber = mobileItems.length - 1; // zero-based
      let mobileCurrentPosition = 0;

      const headerContainerHeight = $('.header__container').height();
      let mobileOffset = headerContainerHeight + 5; // 50px (Navigator negative margin value) - 45px (Main menu height) = 5px

      /**
       * Uncomment to also listen to click events.
       */

      // items.on('click', function() {
      //   items.removeClass('active');
      //   $(this).addClass('active');
      //   const currentDate = $(this).data('history-date');
      //   $('html, body').animate({
      //     scrollTop: $('.history-date__block[data-history-date="' + currentDate + '"]').offset().top - 108
      //   }, 250);
      // });
      //
      // mobileNavigatorNavigation.on('click', function() {
      //   mobileItems.removeClass('active');
      //
      //   if($(this).hasClass('left')) {
      //     mobileNavigatorNavigation.removeClass('history__navigator--mobile__navigation--disabled');
      //     if(mobileCurrentPosition - 1 >= 0) {
      //       mobileCurrentPosition--;
      //       mobileItems.eq(mobileCurrentPosition).addClass('active');
      //       if(mobileCurrentPosition === 0){
      //         $(this).addClass('history__navigator--mobile__navigation--disabled');
      //       }
      //     }
      //   }
      //
      //   if($(this).hasClass('right')) {
      //     mobileNavigatorNavigation.removeClass('history__navigator--mobile__navigation--disabled');
      //     if (mobileCurrentPosition + 1 <= mobileItemsNumber) {
      //       mobileCurrentPosition++;
      //       mobileItems.eq(mobileCurrentPosition).addClass('active');
      //       if(mobileCurrentPosition === mobileItemsNumber){
      //         $(this).addClass('history__navigator--mobile__navigation--disabled');
      //       }
      //     }
      //   }
      //
      //   const currentDate = $('.history__navigator--mobile__date__item.active').data('history-date');
      //   $('html, body').animate({
      //     scrollTop: $('.history-date__block[data-history-date="' + currentDate + '"]').offset().top - 108
      //   }, 250);
      // });



      inView('.history-date__block')
        .on('enter', el => {
          $(el).addClass('in');
          update();
          mobileUpdate();
        })
        .on('exit', el => {
          $(el).removeClass('in');
          update();
          mobileUpdate();
        });

      inView.offset({
        top: 0,
        bottom: 250
      });

      function update() {
        items.removeClass('active');
        let lastInElement = $('.history-date__block.in').last();
        if(!lastInElement.length) {
         lastInElement =  $(window).scrollTop() <= 250 ? $('.history-date__block').first() : $('.history-date__block').last();
        }
        const currentDate = lastInElement.data('history-date');
        const current = $('.history__navigator__date__item[data-history-date="' + currentDate + '"]');
        current.addClass('active');
      }

      function mobileUpdate() {
        mobileNavigator.fadeTo(0, 1);
        mobileItems.removeClass('active');
        let lastInElement = $('.history-date__block.in').last();
        if(!lastInElement.length) {
          mobileNavigator.fadeTo(320, 0);
          lastInElement =  $(window).scrollTop() <= 250 ? $('.history-date__block').first() : $('.history-date__block').last();
        }
        const currentDate = lastInElement.data('history-date');
        const current = $('.history__navigator--mobile__date__item[data-history-date="' + currentDate + '"]');
        current.addClass('active');
        mobileCurrentPosition = current.index();
        mobileNavigatorNavigation.removeClass('history__navigator--mobile__navigation--disabled');

        if(current.index() === 0) {
          mobileNavigatorNavigationLeft.addClass('history__navigator--mobile__navigation--disabled');
        }
        if(current.index() === mobileItemsNumber){
          mobileNavigatorNavigationRight.addClass('history__navigator--mobile__navigation--disabled');
        }

      }

      navigator.stick_in_parent({offset_top: 45});


      $(window).scroll(function(e){
        const isPositionFixed = (mobileNavigator.css('position') === 'fixed');
        if ($(this).scrollTop() > mobileOffset && !isPositionFixed){
          mobileNavigator.addClass('sticky');
        }
        if ($(this).scrollTop() < mobileOffset && isPositionFixed){
          mobileNavigator.removeClass('sticky');
        }
      });

    }
  };
})(document, Drupal, drupalSettings, jQuery, inView);
